import {
  FORTRESS_ACTIVITY_DASHBOARD,
  FORTRESS_BENCHMARK_DASHBOARD,
  FORTRESS_CREATE_REPORTS,
} from 'src/app/reporting/services/ReportingServiceConstants';
import { Policy } from './Policy';
import { PolicyElement } from './PolicyElement';

export class TabsPolicy extends Policy {
  override readonly keyStart = new RegExp(`^${FORTRESS_CREATE_REPORTS}\\.`);

  activityDashboard = new PolicyElement(FORTRESS_ACTIVITY_DASHBOARD);
  benchmarkDashboard = new PolicyElement(FORTRESS_BENCHMARK_DASHBOARD);

  constructor() {
    super();
    this.policyElements.push(this.activityDashboard, this.benchmarkDashboard);
  }
}
